import { Grid, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { FormError } from './hook-form-error';
import { formatValue } from '../../utils/data-format';
import useDebouncedValidation from '../../hooks/use-debounced-hookform-validation';
import { QueryKeyConfig } from '../../api/api-helper';
import { LoadingIndicator } from '../loading-indicator.component';

interface InputFieldProps {
  label: string;
  name: string;
  format: string;
  patternChar?: string;
  disabled?: boolean;
  onBlur?: any;
  isValidateOnChange?: boolean;
  isParentLoading?: boolean;
  validationQueryRoute?: (value: any) => QueryKeyConfig;
}

export const FormFormattedInput = ({ name, label, format, patternChar = '#', disabled, onBlur, isValidateOnChange, isParentLoading, validationQueryRoute }: InputFieldProps): any => {
  const { control } = useFormContext();
  const { validate, isLoading } = useDebouncedValidation({ name, validationQueryRoute });

  const handleChange = (val: any) => {
    if (!isValidateOnChange) {
      validate(val);
    }
  };

  const handleOnBlur = (val: any, originalValue: any) => {
    validate(originalValue);
    onBlur(val);
  };

  return (
    <>
      <Grid container spacing={0}>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <Controller
            control={control}
            name={name}
            render={({ field }) => (
              <>
                <LoadingIndicator isLoading={isLoading || isParentLoading} />
                <TextField
                  className="formatted-input"
                  label={label}
                  variant="outlined"
                  size="small"
                  fullWidth
                  value={formatValue(`${field.value ? field.value : ''}`, format, patternChar)?.formattedValue}
                  name={name}
                  onChange={(e) => {
                    field.onChange(formatValue(e.currentTarget.value, format, patternChar)?.originalValue);
                    handleChange(formatValue(e.currentTarget.value, format, patternChar)?.originalValue);
                  }}
                  onBlur={(e) => {
                    // field?.onBlur(); // Call the original onBlur from react-hook-form
                    handleOnBlur(e?.target?.value, formatValue(e.currentTarget.value, format, patternChar)?.originalValue); // Your custom blur logic
                  }}
                  disabled={disabled}
                />
              </>
            )}
          />
        </Grid>
        <Grid item lg={12} sm={12} xl={12} xs={12}>
          <FormError name={name} />
        </Grid>
      </Grid>
    </>
  );
};

FormFormattedInput.defaultProps = {
  label: undefined,
  name: undefined,
  format: undefined,
  onBlur: () => {
    return;
  },
  onChange: () => {
    return;
  },
};

export default FormFormattedInput;